import {CheckoutGuestsInformationForm} from "./checkoutGuestsInformationForm";
import moment from "moment";
import {__loco} from "../../utils/localization";

export class CheckoutLeaderInformationForm extends CheckoutGuestsInformationForm {

    renderFormTourBlock(item) {
        const {tour: {kids_age_from, kids_not_allowed}} = item;

        let startTime = moment(item.tour.start_time, 'HH:mm:ss').format('hh:mm A');

        /**
         * check if an option was added to cart
         */
        if (item.tour_option !== undefined) {
            startTime = moment(item.tour_option.start_time, 'HH:mm:ss').format('hh:mm A');
        }

        let pickupLocationPicker = ``;
        let hasPickupOptionsClass = '';
        let guestsInformationTitle = ``;
        let scheduledPickupTime = ``;


        if (item.tour.has_pickup_options) {

            // add has pickup options class
            hasPickupOptionsClass = 'has_pickup_options';

            // add guests information header
            guestsInformationTitle = `
        <h4 class="checkout__guest-info_tour__title checkout__guest-info_guests__title">${__loco('Guests')}</h4>
      `;


            // calculate pickup time for the first available pickup option
            let firstPickupOption = item.tour.pickup_options[0];
            let scheduledPickupTimeMoment = moment(startTime, 'hh:mm A').add(firstPickupOption.schedule, 'minutes').format('hh:mm A');
            scheduledPickupTime = `<span class="scheduled_pickup_time" data-start-time="${startTime}">, pickup (approx): ${scheduledPickupTimeMoment}</span>`;


            // create pickup location picker
            pickupLocationPicker = (`
      <div class="select-zone child">
        <span class="checkout__item_label">${__loco('Pickup location')}</span>
        <select class="select-zone__select checkout-tour-pickup-option-select">
          ${item.tour.pickup_options.map((option) => {
                let arrivalTime = '08:00';
                return (`
                <option data-schedule="${option.schedule}" value="${option.id}">${option.name}</option>          
              `);
            }).join('')
            }
          </select>
      </div>

      `);
        }


        /**
         * On pickup option change - re-calculate pickup option
         */
        $(document).on('change', '.checkout-tour-pickup-option-select', function(){
            const $this = $(this);
            const $tourCard = $this.closest('.checkout__guest-info_tour.has_pickup_options');
            const $scheduledPickupTime = $tourCard.find('.scheduled_pickup_time');
            const selected = $this.find('option:selected');

            const startTime = $scheduledPickupTime.data('start-time');
            const schedule = selected.data('schedule');

            let scheduledPickupTimeMoment = moment(startTime, 'hh:mm A').add(schedule, 'minutes').format('hh:mm A');

            $scheduledPickupTime.html(`, ${__loco('pickup (approx)')}: ${scheduledPickupTimeMoment}`);
        });


        return (`
      <div class="checkout__guest-info_tour ${hasPickupOptionsClass}" data-tour-item="${item.tour.id}">
        <div class="checkout__guest-info_tour__header">
          <h4 class="checkout__guest-info_tour__title">
              ${item.tour.name} <span class="starttime"> - ${startTime}${scheduledPickupTime}</span>  
          </h4>
          ${pickupLocationPicker}
        </div>
        ${guestsInformationTitle}
        <div class="checkout__flex-no-pad">
          <div class="checkout__guest-info_adults">
            ${Array(item.request.adults).fill().map(() => `
              <div class="checkout__item_wrapper checkout__guest-info_tour__adult">
                <div class="checkout__item adult">
                  <span class="checkout__item_label">${__loco('Adult name')}</span>
                  <input
                    class="checkout__item_input validate name-input"
                    data-type="letters-required"
                    type="text"
                    placeholder="${__loco('Full Name')}"
                  >
                </div>
                <span class="form-field__error --payment" style="display: none;">${__loco('Please check the field')}</span>
              </div>
            `).join('')}
          </div>
          <div class="checkout__guest-info_children">
            ${Array(item.request.children).fill().map(() => `
              <div class="checkout__guest-info_tour__child">
                <div class="checkout__item_wrapper name-wrapper">
                  <div class="checkout__item child">
                    <span class="checkout__item_label">${__loco('Child name')}</span>
                    <input
                      class="checkout__item_input validate name-input"
                      data-type="letters-required"
                      type="text"
                      placeholder="${__loco('Full Name')}"
                    >
                  </div>
                  <span class="form-field__error --payment" style="display: none;">${__loco('Please check the field')}</span>
                </div>               
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    `);
    }
}